import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import globalContext from '../../../config/context';
import {useHistory} from 'react-router-dom';
import useHook from './drawers.hooks';
// import localforage from 'localforage';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import Image from 'material-ui-image';

//material-ui core
import {Divider, List, ListItem, ListItemIcon, ListItemText, Collapse} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction';
import Switch from '@material-ui/core/Switch/Switch';
import IconButton from '@material-ui/core/IconButton';
import {DropzoneDialog} from 'material-ui-dropzone';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';

//material-ui Icons
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import PrintIcon from '@material-ui/icons/Print';
import HelpIcon from '@material-ui/icons/Help';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import InfoIcon from '@material-ui/icons/Info';
import MapIcon from '@material-ui/icons/Map';
import ExploreIcon from '@material-ui/icons/Explore';
import DevicesIcon from '@material-ui/icons/Devices';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SettingsIcon from '@material-ui/icons/Settings';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import PageviewIcon from '@material-ui/icons/Pageview';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ContactsIcon from '@material-ui/icons/Contacts';
import CalendarViewDayIcon from '@material-ui/icons/CalendarViewDay';
import HomeIcon from '@material-ui/icons/Home';
import HotelIcon from '@material-ui/icons/Hotel';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import TheatersIcon from '@material-ui/icons/Theaters';
import DvrIcon from '@material-ui/icons/Dvr';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
import HdrStrongIcon from '@material-ui/icons/HdrStrong';
import LocalParkingIcon from '@material-ui/icons/LocalParking';
import OpacityIcon from '@material-ui/icons/Opacity';
import TwitterIcon from '@material-ui/icons/Twitter';
import BorderAllIcon from '@material-ui/icons/BorderAll';
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak';
import ColorLensIcon from '@material-ui/icons/ColorLens';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import SortIcon from '@material-ui/icons/Sort';
import SwapCallsIcon from '@material-ui/icons/SwapCalls';
import TerrainIcon from '@material-ui/icons/Terrain';
import FilterCenterFocusIcon from '@material-ui/icons/FilterCenterFocus';
import WhereToVoteIcon from '@material-ui/icons/WhereToVote';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
//import others
import logo from '../../../assets/img/kabupaten.png';
import DialogBdp from './Pbb/DialogZnt';
import DialogSebaranZnt from './Pbb/DialogSebaranZnt';
import DialogKetetapan from './Pbb/DialogKetetapan';
import DialogStatus from './Pbb/DialogStatus';
import DialogCustom from './Custom/DialogCustom';
import DialogUploadKelurahan from './Upload/DialogKelurahan';
import DialogUploadBlok from './Upload/DialogBlok';
import DialogUploadPersil from './Upload/DialogPersil';
import DialogUploadZnt from './Upload/DialogZnt';
import DialogTitikPusat from './Settings/DialogTitikPusat';
import DialogTarget from './Settings/DialogTarget';
import DialogZoom from './Settings/DialogZoom';
import DialogWarna from './Settings/DialogWarna';
import DialogCariNama from './Search/DialogNama';
import DialogCariAlamat from './Search/DialogAlamat';
import DialogCariBlok from './Search/DialogBlok';
import DialogCariKoordinat from './Search/DialogKoordinat';
import Config from '../../../config/config';

const useStyles = makeStyles((theme) => ({
  //drawer
  list: {
    width: 370,
    // width: '80vw',
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  sub_nested: {
    paddingLeft: theme.spacing(7),
  },
  nestedIcon: {
    right: 20,
  },

  //dialog close buttons
  dialogTitle: {
    float: 'right',
    padding: 3,
  },

  buttonUpload: {
    marginRight: 15,
    marginBottom: 5,
    marginTop: 25,
  },

  //img
  divImg: {
    paddingBottom: 10,
  },

  //version
  center: {
    textAlign: 'center',
  },
}));

const styles = {
  img: {
    width: 100,
    // width: 80,
    height: 'auto',
  },
};

const DrawersBrowser = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [
    {
      checkedPbb,
      checkedBphtb,
      checkedHotel,
      checkedRestoran,
      checkedHiburan,
      checkedReklame,
      checkedPpj,
      checkedParkir,
      checkedPat,
      checkedWalet,
      checkedMblb,
      checkedPendataan,
      centroidLatitude,
      centroidLongitude,
      zoomKelurahan,
      zoomBlok,
      zoomPersil,
    },
    {
      setCheckedPbb,
      setCheckedBphtb,
      setCheckedHotel,
      setCheckedRestoran,
      setCheckedHiburan,
      setCheckedReklame,
      setCheckedPpj,
      setCheckedParkir,
      setCheckedPat,
      setCheckedWalet,
      setCheckedMblb,
      setCheckedPendataan,
      setCentroidLatitude,
      setCentroidLongitude,
      setZoomKelurahan,
      setZoomBlok,
      setZoomPersil,
    },
  ] = useAppContext();
  let history = useHistory();
  const {
    drawer,
    setDrawer,
    mapRef,
    getKelurahan,
    getBlok,
    getPersil,
    getZnt,
    markerPbbRefGeoJson,
    getMarkerPbb,
    markerBphtbRefGeoJson,
    getMarkerBphtb,
    markerHotelRefGeoJson,
    getMarkerHotel,
    markerRestoranRefGeoJson,
    getMarkerRestoran,
    markerHiburanRefGeoJson,
    getMarkerHiburan,
    markerReklameRefGeoJson,
    getMarkerReklame,
    markerPpjRefGeoJson,
    getMarkerPpj,
    markerParkirRefGeoJson,
    getMarkerParkir,
    markerPatRefGeoJson,
    getMarkerPat,
    markerWaletRefGeoJson,
    getMarkerWalet,
    markerMblbRefGeoJson,
    getMarkerMblb,
    markerPendataanRefGeoJson,
    getMarkerPendataan,
    setInputNop,
    latitude,
    longitude,
    setLatitude,
    setLongitude,
  } = props;

  const [
    //tematik
    {tahun, setTahun},
    {kecamatan, setKecamatan, kecamatanOptions, handleKecamatan, itemKecamatan},
    {kelurahan, setKelurahan, kelurahanOptions, handleKelurahan, itemKelurahan},
    {blok, setBlok, blokOptions, handleBlok, itemBlok},
    {znt, handleClickZnt, handleCloseZnt},
    {sebaranZnt, handleClickSebaranZnt, handleCloseSebaranZnt},
    {ketetapanPbb, handleClickKetetapanPbb, handleCloseKetetapanPbb},
    {statusPembayaran, handleClickStatusPembayaran, handleCloseStatusPembayaran},
    {
      onZnt,
      onDefault,
      onSebaranZnt,
      onKetetapanPbb,
      onObjekIndividu,
      onJenisTanah,
      onJenisBangunan,
      onKelasTanah,
      onKelasBangunan,
      onStatusPendaftaran,
      onStatusPembayaran,
      onStatusTunggakan,
      onPbb,
      onBphtb,
      onHotel,
      onRestoran,
      onHiburan,
      onReklame,
      onPpj,
      onParkir,
      onPat,
      onWalet,
      onMblb,
      onPendataan,
    },
    //Pencarian
    {cariNama, handleClickCariNama, handleCloseCariNama},
    {onCariNama, onCariNamaButton, handlePressCariNama, nama, setNama, listNama},
    {cariAlamat, handleClickCariAlamat, handleCloseCariAlamat},
    {onCariAlamat, onCariAlamatButton, handlePressCariAlamat, alamat, setAlamat, listAlamat},
    {cariBlok, handleClickCariBlok, handleCloseCariBlok, onResetBlok, onCariBlok},
    {cariKoordinat, handleClickCariKoordinat, handleCloseCariKoordinat, onResetKoordinat, onCariKoordinat},
    //Custom Maps
    {custom, handleClickCustom, handleCloseCustom},
    {onCustom},
    //dialog upload
    {uploadFoto, setUploadFoto, handleClickUploadFoto, handleCloseUploadFoto},
    {uploadKelurahan, setUploadKelurahan, handleClickUploadKelurahan, handleCloseUploadKelurahan},
    {uploadBlok, setUploadBlok, handleClickUploadBlok, handleCloseUploadBlok},
    {uploadPersil, setUploadPersil, handleClickUploadPersil, handleCloseUploadPersil},
    {uploadZnt, setUploadZnt, handleClickUploadZnt, handleCloseUploadZnt},
    //upload file GeoJSON
    {onUploadFoto},
    {
      shpKelurahan,
      shxKelurahan,
      dbfKelurahan,
      shpKelurahanHandler,
      shxKelurahanHandler,
      dbfKelurahanHandler,
      progressKelurahan,
      onUploadKelurahan,
    },
    {shpBlok, shxBlok, dbfBlok, shpBlokHandler, shxBlokHandler, dbfBlokHandler, progressBlok, onUploadBlok},
    {shpPersil, shxPersil, dbfPersil, shpPersilHandler, shxPersilHandler, dbfPersilHandler, progressPersil, onUploadPersil},
    {shpZnt, shxZnt, dbfZnt, shpZntHandler, shxZntHandler, dbfZntHandler, progressZnt, onUploadZnt},
    //others
    {onPrint},
    {titikPusat, setTitikPusat, onTitikPusat, stateTitik, setStateTitik, handleClickTitikPusat, handleCloseTitikPusat},
    {onTarget, stateTarget, setStateTarget, handleClickTarget, handleCloseTarget},
    {zoom, setZoom, onZoom, stateZoom, setStateZoom, handleClickZoom, handleCloseZoom},
    {validZoomKelurahan, validZoomBlok, validZoomPersil, setValidZoomKelurahan, setValidZoomBlok, setValidZoomPersil},
    {listWarna, setListWarna, onWarna, warna, setWarna, handleClickWarna, handleCloseWarna},
  ] = useHook(props);

  //dialog Dashboard----------------------------------------------------------------------------------------------------
  const [dashboard, setDashboard] = React.useState(false);
  const handleClickDashboard = () => {
    setDashboard(true);
  };
  const handleCloseDashboard = () => {
    setDashboard(false);
  };

  //list Expand---------------------------------------------------------------------------------------------------------
  const [openMarker, setOpenMarker] = React.useState(false);
  const handleClickMarker = () => {
    setOpenMarker(!openMarker);
  };
  const [openPbb, setOpenPbb] = React.useState(false);
  const handleClickPbb = () => {
    setOpenPbb(!openPbb);
  };
  const [openJenis, setJenis] = React.useState(false);
  const handleClickJenis = () => {
    setJenis(!openJenis);
  };
  const [openkelas, setkelas] = React.useState(false);
  const handleClickkelas = () => {
    setkelas(!openkelas);
  };
  const [openStatus, setStatus] = React.useState(false);
  const handleClickStatus = () => {
    setStatus(!openStatus);
  };
  const [openPencarian, setOpenPencarian] = React.useState(false);
  const handleClickPencarian = () => {
    setOpenPencarian(!openPencarian);
  };
  const [openUpload, setOpenUpload] = React.useState(false);
  const handleClickUpload = () => {
    setOpenUpload(!openUpload);
  };
  const [openPengaturan, setOpenpengaturan] = React.useState(false);
  const handleClickPengaturan = () => {
    setOpenpengaturan(!openPengaturan);
  };
  const [openHelp, setOpenHelp] = React.useState(false);
  const handleClickHelp = () => {
    setOpenHelp(!openHelp);
  };

  //dialog Search-------------------------------------------------------------------------------------------------------
  const [search, setSearch] = React.useState(false);
  const handleClickSearch = () => {
    setSearch(true);
  };
  const handleCloseSearch = () => {
    setSearch(false);
  };

  //Handle Pendataan -------------------------------------------------------------------------------------------------------
  const handlePendataan = () => {
    if (!checkedPendataan) {
      onPendataan();
    } else {
      markerPendataanRefGeoJson.current.leafletElement.clearLayers();
      setDrawer(false);
    }
    setCheckedPendataan((e) => !e);
  };

  //dialog Tutorials----------------------------------------------------------------------------------------------------
  const [tutorials, setTutorials] = React.useState(false);
  const handleClickTutorials = () => {
    setTutorials(true);
  };
  const handleCloseTutorials = () => {
    setTutorials(false);
  };

  //dialog Version------------------------------------------------------------------------------------------------------
  const [version, setVersion] = React.useState(false);
  const handleClickVersion = () => {
    setVersion(true);
  };
  const handleCloseVersion = () => {
    setVersion(false);
  };

  //logout--------------------------------------------------------------------------------------------------------------
  // const logout = () => {
  //   localforage.clear().then(() => {
  //     history.push('/login');
  //   });
  // };

  return (
    <div className={classes.list}>
      <PerfectScrollbar>
        <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
          <div align={'center'} className={classes.divImg}>
            <Image
              src={logo}
              // imageStyle={styles.img}
              style={styles.img}
              aspectRatio={16 / 5}
              disableSpinner
            />
          </div>

          <Divider variant="middle" />
          <ListItem button onClick={handleClickDashboard}>
            <ListItemIcon>
              <DashboardIcon style={{color: '#212529'}} />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <Dialog
            open={dashboard}
            onClose={handleCloseDashboard}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{'Dashboard'}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" className={classes.center}>
                Login sebagai : <b>Administrator</b>
              </DialogContentText>
            </DialogContent>
            <DialogActions />
          </Dialog>

          {/* PBB */}
          <ListItem button onClick={handleClickPbb}>
            <ListItemIcon>
              <HomeWorkIcon style={{color: '#391a07'}} />
            </ListItemIcon>
            <ListItemText primary="Tematik" />
            {openPbb ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openPbb} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* PBB - ZNT */}
              <ListItem button className={classes.nested} onClick={handleClickZnt}>
                <ListItemIcon>
                  <ConfirmationNumberIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="ZNT" />
              </ListItem>
              <Dialog
                open={znt}
                onClose={handleCloseZnt}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Zona Nilai Tanah :'}</DialogTitle>
                <DialogContent>
                  <DialogBdp
                    tahun={tahun}
                    setTahun={setTahun}
                    kecamatan={kecamatan}
                    setKecamatan={setKecamatan}
                    kecamatanOptions={kecamatanOptions}
                    handleKecamatan={handleKecamatan}
                    itemKecamatan={itemKecamatan}
                    kelurahan={kelurahan}
                    setKelurahan={setKelurahan}
                    kelurahanOptions={kelurahanOptions}
                    handleKelurahan={handleKelurahan}
                    itemKelurahan={itemKelurahan}
                    onZnt={onZnt}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={onZnt} color="primary" autoFocus>
                    Select
                  </Button>
                </DialogActions>
              </Dialog>

              {/* PBB - Blok Peta */}
              <ListItem button className={classes.nested} onClick={onDefault}>
                <ListItemIcon>
                  <MapIcon style={{color: '#431f08'}} />
                </ListItemIcon>
                <ListItemText primary="Blok Peta" />
              </ListItem>

              {/* PBB - Sebaran ZNT */}
              <ListItem button className={classes.nested} onClick={handleClickSebaranZnt}>
                <ListItemIcon>
                  <ExploreIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Sebaran ZNT" />
              </ListItem>
              <Dialog
                open={sebaranZnt}
                onClose={handleCloseSebaranZnt}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Sebaran ZNT :'}</DialogTitle>
                <DialogContent>
                  <DialogSebaranZnt
                    tahun={tahun}
                    setTahun={setTahun}
                    kecamatan={kecamatan}
                    setKecamatan={setKecamatan}
                    kecamatanOptions={kecamatanOptions}
                    handleKecamatan={handleKecamatan}
                    itemKecamatan={itemKecamatan}
                    kelurahan={kelurahan}
                    setKelurahan={setKelurahan}
                    kelurahanOptions={kelurahanOptions}
                    handleKelurahan={handleKelurahan}
                    itemKelurahan={itemKelurahan}
                    onSebaranZnt={onSebaranZnt}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={onSebaranZnt} color="primary" autoFocus>
                    Select
                  </Button>
                </DialogActions>
              </Dialog>

              {/* PBB -  Ketetapan PBB*/}
              <ListItem button className={classes.nested} onClick={handleClickKetetapanPbb}>
                <ListItemIcon>
                  <LibraryBooksIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Pengelompokan Ketetapan PBB" />
              </ListItem>
              <Dialog
                open={ketetapanPbb}
                onClose={handleCloseKetetapanPbb}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Masukkan Tahun Pajak'}</DialogTitle>
                <DialogContent>
                  <DialogKetetapan tahun={tahun} setTahun={setTahun} onKetetapanPbb={onKetetapanPbb} />
                </DialogContent>
                <DialogActions>
                  <Button onClick={onKetetapanPbb} color="primary" autoFocus>
                    Select
                  </Button>
                </DialogActions>
              </Dialog>

              {/* PBB - Objek Individu*/}
              <ListItem button className={classes.nested} onClick={onObjekIndividu}>
                <ListItemIcon>
                  <DevicesIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Objek yang Dinilai Secara Individu" />
              </ListItem>

              {/* PBB - Jenis Objek Pajak*/}
              <ListItem button className={classes.nested} onClick={handleClickJenis}>
                <ListItemIcon>
                  <SortIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Jenis Objek Pajak" />
                {openJenis ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={openJenis} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {/* Jenis Tanah */}
                  <ListItem button className={classes.sub_nested} onClick={onJenisTanah}>
                    <ListItemIcon>
                      <TerrainIcon style={{color: '#008339'}} />
                    </ListItemIcon>
                    <ListItemText primary="Jenis Tanah" />
                  </ListItem>

                  {/* Jenis Bangunan */}
                  <ListItem button className={classes.sub_nested} onClick={onJenisBangunan}>
                    <ListItemIcon>
                      <EmojiTransportationIcon style={{color: '#212529'}} />
                    </ListItemIcon>
                    <ListItemText primary="Jenis Bangunan" />
                  </ListItem>
                </List>
              </Collapse>

              {/* PBB - Kelas Objek Pajak*/}
              <ListItem button className={classes.nested} onClick={handleClickkelas}>
                <ListItemIcon>
                  <SwapCallsIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Kelas Objek Pajak" />
                {openkelas ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={openkelas} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {/* Kelas Tanah */}
                  <ListItem button className={classes.sub_nested} onClick={onKelasTanah}>
                    <ListItemIcon>
                      <TerrainIcon style={{color: '#008339'}} />
                    </ListItemIcon>
                    <ListItemText primary="Kelas Tanah" />
                  </ListItem>

                  {/* kelas Bangunan */}
                  <ListItem button className={classes.sub_nested} onClick={onKelasBangunan}>
                    <ListItemIcon>
                      <EmojiTransportationIcon style={{color: '#212529'}} />
                    </ListItemIcon>
                    <ListItemText primary="Kelas Bangunan" />
                  </ListItem>
                </List>
              </Collapse>

              {/* PBB - Status Objek Pajak*/}
              <ListItem button className={classes.nested} onClick={handleClickStatus}>
                <ListItemIcon>
                  <MonetizationOnIcon style={{color: '#F39C12'}} />
                </ListItemIcon>
                <ListItemText primary="Status Objek Pajak" />
                {openStatus ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={openStatus} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {/* Status Pendaftaran */}
                  <ListItem button className={classes.sub_nested} onClick={onStatusPendaftaran}>
                    <ListItemIcon>
                      <ControlPointIcon style={{color: '#212529'}} />
                    </ListItemIcon>
                    <ListItemText primary="Pendaftaran" />
                  </ListItem>

                  {/* Status Pembayaran */}
                  <ListItem button className={classes.sub_nested} onClick={handleClickStatusPembayaran}>
                    <ListItemIcon>
                      <TrendingUpIcon style={{color: '#008f3f'}} />
                    </ListItemIcon>
                    <ListItemText primary="Pembayaran" />
                  </ListItem>
                  <Dialog
                    open={statusPembayaran}
                    onClose={handleCloseStatusPembayaran}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{'Masukkan Tahun Pajak'}</DialogTitle>
                    <DialogContent>
                      <DialogStatus tahun={tahun} setTahun={setTahun} onStatusPembayaran={onStatusPembayaran} />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={onStatusPembayaran} color="primary" autoFocus>
                        Select
                      </Button>
                    </DialogActions>
                  </Dialog>

                  {/* Status Tunggakan */}
                  <ListItem button className={classes.sub_nested} onClick={onStatusTunggakan}>
                    <ListItemIcon>
                      <TrendingDownIcon style={{color: '#db3828'}} />
                    </ListItemIcon>
                    <ListItemText primary="Tunggakan" />
                  </ListItem>
                </List>
              </Collapse>
              {/*------*/}
            </List>
          </Collapse>

          {/* MARKER */}
          <ListItem button onClick={handleClickMarker}>
            <ListItemIcon>
              <CalendarViewDayIcon />
            </ListItemIcon>
            <ListItemText primary="Marker" />
            {openMarker ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openMarker} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* PBB */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-pbb" primary="PBB" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onPbb}
                    checked={checkedPbb}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-pbb'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>

              {/* BPHTB */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <LocationCityIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-bphtb" primary="BPHTB" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onBphtb}
                    checked={checkedBphtb}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-bphtb'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>

              {/* Hotel */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <HotelIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-hotel" primary="Pajak Hotel" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onHotel}
                    checked={checkedHotel}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-hotel'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>

              {/* Restoran */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <RestaurantIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-restoran" primary="Pajak Restoran" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onRestoran}
                    checked={checkedRestoran}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-restoran'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>

              {/* Hiburan */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <TheatersIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-hiburan" primary="Pajak Hiburan" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onHiburan}
                    checked={checkedHiburan}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-hiburan'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>

              {/* Reklame */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <DvrIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-reklame" primary="Pajak Reklame" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onReklame}
                    checked={checkedReklame}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-reklame'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>

              {/* Penerangan Jalan */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <WbIncandescentIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-ppj" primary="Pajak Penerangan Jalan" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onPpj}
                    checked={checkedPpj}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-ppj'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>

              {/* parkir */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <LocalParkingIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-parkir" primary="Pajak Parkir" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onParkir}
                    checked={checkedParkir}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-parkir'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>

              {/* Air Tanah */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <OpacityIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-air" primary="Pajak Air Tanah" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onPat}
                    checked={checkedPat}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-air'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>

              {/* Sarang Burung Wallet */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <TwitterIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-wallet" primary="Pajak Burung Wallet" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onWalet}
                    checked={checkedWalet}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-wallet'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>

              {/* Mineral bukan Logam dan Batuan */}
              <ListItem className={classes.nested}>
                <ListItemIcon>
                  <HdrStrongIcon />
                </ListItemIcon>
                <ListItemText id="checkbox-list-secondary-label-mblb" primary="Pajak MBLB" />
                <ListItemSecondaryAction className={classes.nestedIcon}>
                  <Checkbox
                    edge="end"
                    color="primary"
                    onChange={onMblb}
                    checked={checkedMblb}
                    inputProps={{'aria-labelledby': 'checkbox-list-secondary-label-mblb'}}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            </List>
          </Collapse>

          <Divider variant="middle" />

          {/* Custom Maps */}
          {/*<ListItem button onClick={handleClickCustom}>*/}
          {/*  <ListItemIcon>*/}
          {/*    <EditIcon style={{color: '#212529'}} />*/}
          {/*  </ListItemIcon>*/}
          {/*  <ListItemText primary="Custom Maps" />*/}
          {/*</ListItem>*/}
          {/*<Dialog*/}
          {/*  open={custom}*/}
          {/*  onClose={handleCloseCustom}*/}
          {/*  aria-labelledby="alert-dialog-title"*/}
          {/*  aria-describedby="alert-dialog-description">*/}
          {/*  <DialogTitle id="alert-dialog-title">{'Custom Maps'}</DialogTitle>*/}
          {/*  <DialogContent>*/}
          {/*    <DialogCustom />*/}
          {/*  </DialogContent>*/}
          {/*  <DialogActions>*/}
          {/*    <Button onClick={onCustom} color="primary" autoFocus target="_blank" href={'/' + Config.homepage + '/custom/'}>*/}
          {/*      Select*/}
          {/*    </Button>*/}
          {/*  </DialogActions>*/}
          {/*</Dialog>*/}

          {/* Pendataan */}
          <ListItem>
            <ListItemIcon>
              <AssignmentIcon style={{color: '#607D8B'}} />
            </ListItemIcon>
            <ListItemText id="switch-list-label-pendataan" primary="Pendataan" />
            <ListItemSecondaryAction>
              <Switch
                edge="end"
                color="primary"
                onChange={handlePendataan}
                checked={checkedPendataan}
                inputProps={{'aria-labelledby': 'switch-list-label-pendataan'}}
              />
            </ListItemSecondaryAction>
          </ListItem>

          {/* pencarian */}
          <ListItem button onClick={handleClickPencarian}>
            <ListItemIcon>
              <PageviewIcon style={{color: '#212529'}} />
            </ListItemIcon>
            <ListItemText primary="Pencarian" />
            {openPencarian ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openPencarian} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* Pencarian Nama */}
              <ListItem button className={classes.nested} onClick={handleClickCariNama}>
                <ListItemIcon>
                  <AccountCircleIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Nama" />
              </ListItem>
              <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={cariNama}
                onClose={handleCloseCariNama}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Masukkan Nama Wajib Pajak :'}</DialogTitle>
                <DialogContent>
                  <DialogCariNama
                    nama={nama}
                    setNama={setNama}
                    listNama={listNama}
                    onCariNama={onCariNama}
                    onCariNamaButton={onCariNamaButton}
                    handlePressCariNama={handlePressCariNama}
                  />
                </DialogContent>
              </Dialog>

              {/* Pencarian Alamat */}
              <ListItem button className={classes.nested} onClick={handleClickCariAlamat}>
                <ListItemIcon>
                  <ContactsIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Alamat" />
              </ListItem>
              <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={cariAlamat}
                onClose={handleCloseCariAlamat}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Masukkan Alamat Objek Pajak :'}</DialogTitle>
                <DialogContent>
                  <DialogCariAlamat
                    alamat={alamat}
                    setAlamat={setAlamat}
                    listAlamat={listAlamat}
                    onCariAlamat={onCariAlamat}
                    onCariAlamatButton={onCariAlamatButton}
                    handlePressCariAlamat={handlePressCariAlamat}
                  />
                </DialogContent>
              </Dialog>

              {/* Pencarian Blok */}
              <ListItem button className={classes.nested} onClick={handleClickCariBlok}>
                <ListItemIcon>
                  <BorderAllIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Blok" />
              </ListItem>
              <Dialog
                open={cariBlok}
                onClose={handleCloseCariBlok}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Pilih Blok :'}</DialogTitle>
                <DialogContent>
                  <DialogCariBlok
                    kecamatan={kecamatan}
                    setKecamatan={setKecamatan}
                    kecamatanOptions={kecamatanOptions}
                    handleKecamatan={handleKecamatan}
                    itemKecamatan={itemKecamatan}
                    kelurahan={kelurahan}
                    setKelurahan={setKelurahan}
                    kelurahanOptions={kelurahanOptions}
                    handleKelurahan={handleKelurahan}
                    itemKelurahan={itemKelurahan}
                    blok={blok}
                    setBlok={setBlok}
                    blokOptions={blokOptions}
                    handleBlok={handleBlok}
                    itemBlok={itemBlok}
                    onCariBlok={onCariBlok}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={onResetBlok} color="secondary" autoFocus>
                    Reset
                  </Button>
                  <Button onClick={onCariBlok} color="primary" autoFocus>
                    Select
                  </Button>
                </DialogActions>
              </Dialog>

              {/*Pencarian Koordinat */}
              <ListItem button className={classes.nested} onClick={handleClickCariKoordinat}>
                <ListItemIcon>
                  <CenterFocusWeakIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Koordinat" />
              </ListItem>
              <Dialog
                open={cariKoordinat}
                onClose={handleCloseCariKoordinat}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Masukkan Koordinat :'}</DialogTitle>
                <DialogContent>
                  <DialogCariKoordinat
                    latitude={latitude}
                    setLatitude={setLatitude}
                    longitude={longitude}
                    setLongitude={setLongitude}
                    onCariKoordinat={onCariKoordinat}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={onResetKoordinat} color="secondary" autoFocus>
                    Reset
                  </Button>
                  <Button onClick={onCariKoordinat} color="primary" autoFocus>
                    Select
                  </Button>
                </DialogActions>
              </Dialog>
            </List>
          </Collapse>

          {/* Upload */}
          <ListItem button onClick={handleClickUpload}>
            <ListItemIcon>
              <CloudUploadIcon style={{color: '#2196F3'}} />
            </ListItemIcon>
            <ListItemText primary="Upload" />
            {openUpload ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openUpload} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* Upload Foto Objek */}
              <ListItem button className={classes.nested} onClick={handleClickUploadFoto}>
                <ListItemIcon>
                  <AttachFileIcon />
                </ListItemIcon>
                <ListItemText primary="Foto Objek" />
              </ListItem>
              <DropzoneDialog
                open={uploadFoto}
                onClose={handleCloseUploadFoto}
                acceptedFiles={['image/*']}
                cancelButtonText={'cancel'}
                submitButtonText={'submit'}
                maxFileSize={5000000}
                onSave={(images) => {
                  onUploadFoto(images);
                }}
                showPreviews={true}
                showFileNamesInPreview={true}
              />

              {/* Upload Kelurahan */}
              <ListItem button className={classes.nested} onClick={handleClickUploadKelurahan}>
                <ListItemIcon>
                  <AttachFileIcon />
                </ListItemIcon>
                <ListItemText primary="Kelurahan" />
              </ListItem>
              <Dialog open={uploadKelurahan} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                  {'Upload Kelurahan :'}
                  <IconButton className={classes.dialogTitle} onClick={handleCloseUploadKelurahan}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogUploadKelurahan
                    kecamatan={kecamatan}
                    setKecamatan={setKecamatan}
                    kecamatanOptions={kecamatanOptions}
                    handleKecamatan={handleKecamatan}
                    itemKecamatan={itemKecamatan}
                    shpKelurahan={shpKelurahan}
                    shxKelurahan={shxKelurahan}
                    dbfKelurahan={dbfKelurahan}
                    shpKelurahanHandler={shpKelurahanHandler}
                    shxKelurahanHandler={shxKelurahanHandler}
                    dbfKelurahanHandler={dbfKelurahanHandler}
                    progressKelurahan={progressKelurahan}
                    onUploadKelurahan={onUploadKelurahan}
                  />
                </DialogContent>
                <DialogActions>
                  {/*  /!*<Button onClick={onUploadKelurahan} color="primary" variant="contained">*!/*/}
                  {/*  /!*  Upload*!/*/}
                  {/*  /!*</Button>*!/*/}
                </DialogActions>
              </Dialog>

              {/* Upload Blok */}
              <ListItem button className={classes.nested} onClick={handleClickUploadBlok}>
                <ListItemIcon>
                  <AttachFileIcon />
                </ListItemIcon>
                <ListItemText primary="Blok" />
              </ListItem>
              <Dialog open={uploadBlok} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                  {'Upload Blok :'}
                  <IconButton className={classes.dialogTitle} onClick={handleCloseUploadBlok}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogUploadBlok
                    kecamatan={kecamatan}
                    setKecamatan={setKecamatan}
                    kecamatanOptions={kecamatanOptions}
                    handleKecamatan={handleKecamatan}
                    itemKecamatan={itemKecamatan}
                    kelurahan={kelurahan}
                    setKelurahan={setKelurahan}
                    kelurahanOptions={kelurahanOptions}
                    handleKelurahan={handleKelurahan}
                    itemKelurahan={itemKelurahan}
                    shpBlok={shpBlok}
                    shxBlok={shxBlok}
                    dbfBlok={dbfBlok}
                    shpBlokHandler={shpBlokHandler}
                    shxBlokHandler={shxBlokHandler}
                    dbfBlokHandler={dbfBlokHandler}
                    progressBlok={progressBlok}
                    onUploadBlok={onUploadBlok}
                  />
                </DialogContent>
                <DialogActions>
                  {/*<Button onClick={handleCloseUploadBlok} color="secondary">*/}
                  {/*  Cancel*/}
                  {/*</Button>*/}
                  {/*<Button onClick={onUploadBlok} color="primary" autoFocus>*/}
                  {/*  Upload*/}
                  {/*</Button>*/}
                </DialogActions>
              </Dialog>

              {/* Upload Persil */}
              <ListItem button className={classes.nested} onClick={handleClickUploadPersil}>
                <ListItemIcon>
                  <AttachFileIcon />
                </ListItemIcon>
                <ListItemText primary="Persil" />
              </ListItem>
              <Dialog open={uploadPersil} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                  {'Upload Persil :'}
                  <IconButton className={classes.dialogTitle} onClick={handleCloseUploadPersil}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogUploadPersil
                    kecamatan={kecamatan}
                    setKecamatan={setKecamatan}
                    kecamatanOptions={kecamatanOptions}
                    handleKecamatan={handleKecamatan}
                    itemKecamatan={itemKecamatan}
                    kelurahan={kelurahan}
                    setKelurahan={setKelurahan}
                    kelurahanOptions={kelurahanOptions}
                    handleKelurahan={handleKelurahan}
                    itemKelurahan={itemKelurahan}
                    shpPersil={shpPersil}
                    shxPersil={shxPersil}
                    dbfPersil={dbfPersil}
                    shpPersilHandler={shpPersilHandler}
                    shxPersilHandler={shxPersilHandler}
                    dbfPersilHandler={dbfPersilHandler}
                    progressPersil={progressPersil}
                    onUploadPersil={onUploadPersil}
                  />
                </DialogContent>
                <DialogActions>
                  {/*  <Button onClick={handleCloseUploadPersil} color="secondary">*/}
                  {/*    Cancel*/}
                  {/*  </Button>*/}
                  {/*  <Button onClick={onUploadPersil} color="primary" autoFocus>*/}
                  {/*    Upload*/}
                  {/*  </Button>*/}
                </DialogActions>
              </Dialog>

              {/* Upload ZNT */}
              <ListItem button className={classes.nested} onClick={handleClickUploadZnt}>
                <ListItemIcon>
                  <AttachFileIcon />
                </ListItemIcon>
                <ListItemText primary="ZNT" />
              </ListItem>
              <Dialog open={uploadZnt} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                  {'Upload ZNT :'}
                  <IconButton className={classes.dialogTitle} onClick={handleCloseUploadZnt}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogUploadZnt
                    kecamatan={kecamatan}
                    setKecamatan={setKecamatan}
                    kecamatanOptions={kecamatanOptions}
                    handleKecamatan={handleKecamatan}
                    itemKecamatan={itemKecamatan}
                    kelurahan={kelurahan}
                    setKelurahan={setKelurahan}
                    kelurahanOptions={kelurahanOptions}
                    handleKelurahan={handleKelurahan}
                    itemKelurahan={itemKelurahan}
                    shpZnt={shpZnt}
                    shxZnt={shxZnt}
                    dbfZnt={dbfZnt}
                    shpZntHandler={shpZntHandler}
                    shxZntHandler={shxZntHandler}
                    dbfZntHandler={dbfZntHandler}
                    progressZnt={progressZnt}
                    onUploadZnt={onUploadZnt}
                  />
                </DialogContent>
                <DialogActions>
                  {/*<Button onClick={handleCloseUploadZnt} color="secondary">*/}
                  {/*  Cancel*/}
                  {/*</Button>*/}
                  {/*<Button onClick={onUploadZnt} color="primary" autoFocus>*/}
                  {/*  Upload*/}
                  {/*</Button>*/}
                </DialogActions>
              </Dialog>
            </List>
          </Collapse>

          {/* Print */}
          <ListItem button onClick={onPrint}>
            <ListItemIcon>
              <PrintIcon style={{color: '#01579b'}} />
            </ListItemIcon>
            <ListItemText primary="Print" />
          </ListItem>

          {/* Pengaturan */}
          <ListItem button onClick={handleClickPengaturan}>
            <ListItemIcon>
              <SettingsIcon style={{color: '#212529'}} />
            </ListItemIcon>
            <ListItemText primary="Pengaturan" />
            {openPengaturan ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openPengaturan} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* Pengaturan - Titik Pusat */}
              <ListItem button className={classes.nested} onClick={handleClickTitikPusat}>
                <ListItemIcon>
                  <FilterCenterFocusIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Titik Pusat" />
              </ListItem>
              <Dialog
                open={stateTitik}
                onClose={handleCloseTitikPusat}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Pengaturan Titik Pusat :'}</DialogTitle>
                <DialogContent>
                  <DialogTitikPusat onTitikPusat={onTitikPusat} />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseTitikPusat} color="secondary">
                    Cancel
                  </Button>
                  <Button onClick={onTitikPusat} color="primary" autoFocus>
                    Save
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Pengaturan - Target Pendataan */}
              <ListItem button className={classes.nested} onClick={handleClickTarget}>
                <ListItemIcon>
                  <WhereToVoteIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Target Pendataan" />
              </ListItem>
              <Dialog
                open={stateTarget}
                onClose={handleCloseTarget}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Pengaturan Target Pendataan :'}</DialogTitle>
                <DialogContent>
                  <DialogTarget onTarget={onTarget} />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseTarget} color="secondary">
                    Cancel
                  </Button>
                  <Button onClick={onTarget} color="primary" autoFocus>
                    Save
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Pengaturan - Zoom */}
              <ListItem button className={classes.nested} onClick={handleClickZoom}>
                <ListItemIcon>
                  <AspectRatioIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Zoom" />
              </ListItem>
              <Dialog
                open={stateZoom}
                onClose={handleCloseZoom}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Pengaturan Zoom :'}</DialogTitle>
                <DialogContent>
                  <DialogZoom
                    onZoom={onZoom}
                    validZoomKelurahan={validZoomKelurahan}
                    validZoomBlok={validZoomBlok}
                    validZoomPersil={validZoomPersil}
                    setValidZoomKelurahan={setValidZoomKelurahan}
                    setValidZoomBlok={setValidZoomBlok}
                    setValidZoomPersil={setValidZoomPersil}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseZoom} color="secondary">
                    Cancel
                  </Button>
                  <Button disabled={validZoomKelurahan || validZoomBlok || validZoomPersil} onClick={onZoom} color="primary" autoFocus>
                    Save
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Pengaturan - Warna */}
              <ListItem button className={classes.nested} onClick={handleClickWarna}>
                <ListItemIcon>
                  <ColorLensIcon style={{color: '#212529'}} />
                </ListItemIcon>
                <ListItemText primary="Warna" />
              </ListItem>
              <Dialog
                open={warna}
                onClose={handleCloseWarna}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Pengaturan Warna :'}</DialogTitle>
                <DialogContent>
                  <DialogWarna listWarna={listWarna} setListWarna={setListWarna} />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseWarna} color="secondary">
                    Cancel
                  </Button>
                  <Button onClick={onWarna} color="primary" autoFocus>
                    Save
                  </Button>
                </DialogActions>
              </Dialog>
            </List>
          </Collapse>

          {/*<ListItem button onClick={logout}>*/}
          {/*  <ListItemIcon>*/}
          {/*    <ExitToAppIcon style={{color: '#C0392B'}} />*/}
          {/*  </ListItemIcon>*/}
          {/*  <ListItemText primary="Logout" />*/}
          {/*</ListItem>*/}
        </List>
      </PerfectScrollbar>
    </div>
  );
};

export default DrawersBrowser;
